import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Collection } from '../shared';
import { IFeatureFlag } from '../shared/types';
import { API_COMMON } from '../shared/enum';
import { filter, map, take, tap } from 'rxjs/operators';
import { SyncApiService } from '../../shared/services/sync-api.service';

const LOADING_FLAGS = 'LOADING_FLAGS';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagApiService {
  public readonly flags$: Collection<IFeatureFlag> = new Collection<IFeatureFlag>({
    indexBy: 'name',
    allowMultiselect: true,
  });

  public getFlags = (): Observable<string[]> => {
    const { flags$, api } = this;

    if (!flags$.isWaiting(LOADING_FLAGS) && !flags$.size) {
      flags$.setWaiting(LOADING_FLAGS, true);

      api
        .get(API_COMMON.FEATURE_FLAG)
        .pipe(
          take(1),
          tap((flags: IFeatureFlag[]) => flags$.replaceAll(flags).select(flags.filter(f => f.isActive))),
          tap(() => flags$.setWaiting(LOADING_FLAGS, false))
        )
        .subscribe();
    }

    return flags$.onSelect().pipe(
      filter(() => !!flags$.size),
      map(() => (flags$.selection as IFeatureFlag[]).map(f => f.name)),
      take(1)
    );
  };

  public getFlag = (flag: string): Observable<boolean> => {
    const { flags$, getFlags } = this;
    return getFlags().pipe(map(() => flags$.isSelected(flag)));
  };

  constructor(private api: SyncApiService) {}
}
